import React from 'react'
import PropTypes from 'prop-types'
import styles from './HostingBlockRecommendedTag.scss'

const HostingBlockRecommendedTag = ({text, className}) => {
	const classNames = [styles.container]
	if (className) {
		classNames.push(className)
	}
	return <div className={classNames.join(' ')}>{text}</div>
}

HostingBlockRecommendedTag.propTypes = {
	text: PropTypes.string.isRequired,
	className: PropTypes.string,
}

export default HostingBlockRecommendedTag
